module.exports = __webpack_public_path__ + "static/img/img_login_mobile_bg_01.4e27447b.jpg";